"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLiquidationAmount = exports.calculateCollateralPadded = exports.calculateCollateralNeeded = exports.calculateLiquidationPrice = void 0;
var ethers_1 = require("ethers");
var constants_1 = require("../constants");
var ArcNumber_1 = __importDefault(require("./ArcNumber"));
function calculateLiquidationPrice(currentPrice, liquidationRatio) {
    return ArcNumber_1.default.bigMul(ethers_1.BigNumber.from(currentPrice), constants_1.BASE.sub(liquidationRatio));
}
exports.calculateLiquidationPrice = calculateLiquidationPrice;
function calculateCollateralNeeded(borrowedAmount, price, collateralRatio) {
    return ArcNumber_1.default.bigDiv(ArcNumber_1.default.bigMul(ethers_1.BigNumber.from(borrowedAmount), collateralRatio), price);
}
exports.calculateCollateralNeeded = calculateCollateralNeeded;
function calculateCollateralPadded(collateralAmount, liquidationRatio) {
    return ArcNumber_1.default.bigMul(ethers_1.BigNumber.from(collateralAmount), constants_1.BASE.add(liquidationRatio));
}
exports.calculateCollateralPadded = calculateCollateralPadded;
function calculateLiquidationAmount(collateralAmount, borrowedAmount, currentPrice, liquidationRatio, collateralRatio, arcRatio) {
    var liquidationPrice = calculateLiquidationPrice(currentPrice, liquidationRatio);
    var collateralNeeded = calculateCollateralNeeded(borrowedAmount, liquidationPrice, collateralRatio);
    var collateralToLiquidate = calculateCollateralPadded(collateralNeeded.sub(collateralAmount), liquidationRatio);
    var borrowToLiquidate = ArcNumber_1.default.bigMul(collateralToLiquidate, liquidationPrice);
    var newCollateralAmount = ethers_1.BigNumber.from(collateralAmount).sub(collateralToLiquidate);
    var newBorrowAmount = ethers_1.BigNumber.from(borrowedAmount).sub(borrowToLiquidate);
    var collateralProfit = collateralToLiquidate.sub(ArcNumber_1.default.bigDiv(borrowToLiquidate, currentPrice));
    var arcProft = ArcNumber_1.default.bigMul(collateralProfit, arcRatio);
    return {
        debtNeededToLiquidate: borrowToLiquidate,
        collateralLiquidated: collateralToLiquidate,
        newDebtAmount: newBorrowAmount,
        newCollateralAmount: newCollateralAmount,
        collateralToArc: arcProft,
    };
}
exports.calculateLiquidationAmount = calculateLiquidationAmount;
//# sourceMappingURL=calculations.js.map